import React from 'react'
import AdminLayout from './AdminLayout'

const ShoppingHistory = () => {
  return (
    <>
      <AdminLayout>
        <div className="shoppingHistory">
          <h1 className="h1">История покупок <span className="ml-4"><img src="/assets/icon/bag.svg" alt="" /></span></h1>

          <div className="row">

            <div className="col-4">
              <div className="card myShadows">
                <div className="card-body">
                  <div className="img">
                    <div className="iconWrap"><i className="icon icon-heart"></i></div>
                    <img src="/assets/image/main2.png" className='w-100' alt="" />
                  </div>



                  <div className="d-flex align-items-center justify-content-between">
                    <button className="btn myBtn">Футболка “Marell” </button>
                    <button className="btn secondaryBtn">19.01</button>
                  </div>

                  <div className='d-flex align-items-center justify-content-between bottomWrap'>
                    <div>
                      <h3>RUB</h3>
                      <h4>1600 P</h4>
                    </div>

                    <div>
                      <h3>AMARELL</h3>
                      <h4>94</h4>
                    </div>

                    <div className='d-flex align-items-center '>
                      <i className="icon icon-star"></i>
                      <i className="icon icon-star"></i>
                      <i className="icon icon-star"></i>
                      <i className="icon icon-star"></i>
                      <i className="icon icon-star"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
            <div className="col-4">
              <div className="card myShadows">
                <div className="card-body">
                  <div className="img">
                    <div className="iconWrap"><i className="icon icon-heart"></i></div>
                    <img src="/assets/image/main2.png" className='w-100' alt="" />
                  </div>

                  <div className="d-flex align-items-center justify-content-between">
                    <button className="btn myBtn">Футболка “Marell” </button>
                    <button className="btn secondaryBtn">19.01</button>
                  </div>

                  <div className='d-flex align-items-center justify-content-between bottomWrap'>
                    <div>
                      <h3>RUB</h3>
                      <h4>1600 P</h4>
                    </div>

                    <div>
                      <h3>AMARELL</h3>
                      <h4>94</h4>
                    </div>

                    <div className='d-flex align-items-center '>
                      <i className="icon icon-star"></i>
                      <i className="icon icon-star"></i>
                      <i className="icon icon-star"></i>
                      <i className="icon icon-star"></i>
                      <i className="icon icon-star"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
            <div className="col-4">
              <div className="card myShadows">
                <div className="card-body">
                  <div className="img">
                    <div className="iconWrap"><i className="icon icon-heart"></i></div>
                    <img src="/assets/image/main2.png" className='w-100' alt="" />
                  </div>

                  <div className="d-flex align-items-center justify-content-between">
                    <button className="btn myBtn">Футболка “Marell” </button>
                    <button className="btn secondaryBtn">19.01</button>
                  </div>

                  <div className='d-flex align-items-center justify-content-between bottomWrap'>
                    <div>
                      <h3>RUB</h3>
                      <h4>1600 P</h4>
                    </div>

                    <div>
                      <h3>AMARELL</h3>
                      <h4>94</h4>
                    </div>

                    <div className='d-flex align-items-center '>
                      <i className="icon icon-star"></i>
                      <i className="icon icon-star"></i>
                      <i className="icon icon-star"></i>
                      <i className="icon icon-star"></i>
                      <i className="icon icon-star"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
            <div className="col-4">
              <div className="card myShadows">
                <div className="card-body">
                  <div className="img">
                    <div className="iconWrap"><i className="icon icon-heart"></i></div>
                    <img src="/assets/image/main2.png" className='w-100' alt="" />
                  </div>

                  <div className="d-flex align-items-center justify-content-between">
                    <button className="btn myBtn">Футболка “Marell” </button>
                    <button className="btn secondaryBtn">19.01</button>
                  </div>

                  <div className='d-flex align-items-center justify-content-between bottomWrap'>
                    <div>
                      <h3>RUB</h3>
                      <h4>1600 P</h4>
                    </div>

                    <div>
                      <h3>AMARELL</h3>
                      <h4>94</h4>
                    </div>

                    <div className='d-flex align-items-center '>
                      <i className="icon icon-star"></i>
                      <i className="icon icon-star"></i>
                      <i className="icon icon-star"></i>
                      <i className="icon icon-star"></i>
                      <i className="icon icon-star"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
            <div className="col-4">
              <div className="card myShadows">
                <div className="card-body">
                  <div className="img">
                    <div className="iconWrap"><i className="icon icon-heart"></i></div>
                    <img src="/assets/image/main2.png" className='w-100' alt="" />
                  </div>

                  <div className="d-flex align-items-center justify-content-between">
                    <button className="btn myBtn">Футболка “Marell” </button>
                    <button className="btn secondaryBtn">19.01</button>
                  </div>

                  <div className='d-flex align-items-center justify-content-between bottomWrap'>
                    <div>
                      <h3>RUB</h3>
                      <h4>1600 P</h4>
                    </div>

                    <div>
                      <h3>AMARELL</h3>
                      <h4>94</h4>
                    </div>

                    <div className='d-flex align-items-center '>
                      <i className="icon icon-star"></i>
                      <i className="icon icon-star"></i>
                      <i className="icon icon-star"></i>
                      <i className="icon icon-star"></i>
                      <i className="icon icon-star"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
            <div className="col-4">
              <div className="card myShadows">
                <div className="card-body">
                  <div className="img">
                    <div className="iconWrap"><i className="icon icon-heart"></i></div>
                    <img src="/assets/image/main2.png" className='w-100' alt="" />
                  </div>

                  <div className="d-flex align-items-center justify-content-between">
                    <button className="btn myBtn">Футболка “Marell” </button>
                    <button className="btn secondaryBtn">19.01</button>
                  </div>

                  <div className='d-flex align-items-center justify-content-between bottomWrap'>
                    <div>
                      <h3>RUB</h3>
                      <h4>1600 P</h4>
                    </div>

                    <div>
                      <h3>AMARELL</h3>
                      <h4>94</h4>
                    </div>

                    <div className='d-flex align-items-center '>
                      <i className="icon icon-star"></i>
                      <i className="icon icon-star"></i>
                      <i className="icon icon-star"></i>
                      <i className="icon icon-star"></i>
                      <i className="icon icon-star"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </AdminLayout>
    </>
  )
}

export default ShoppingHistory